<template>
  <div class="real-area">
    <!-- 仓库信息 -->
    <div class="real-area-left">
      <div
        v-show="warehouseList.length"
        class="warehouse-row"
        :class="{'is-active': activeIndex === index}"
        v-for="(item, index) in warehouseList"
        :key="index"
        @click="selectWarehouse(item, index)"
      >
        <div class="warehouse-row-title">
          <img class="warehouse-img" src="../../../../assets/images/warehouse/warehouse.png">
          <span class="warehouse-name" :title="item.name">{{ item.name }}</span>
        </div>
        <div class="nums-info">
          <div class="goods-shelves">
            <p class="goods-shelves-nums">{{ item.totalAmount }}</p>
            <p class="goods-shelves-title">工人工资(元)</p>
          </div>
          <div class="goods-shelves">
            <p class="goods-shelves-nums">{{ item.totalTimes }}</p>
            <p class="goods-shelves-title">总工时(h)</p>
          </div>
        </div>
      </div>

      <div v-if="!warehouseList.length" class="nothing">
        <img class="nothing-img" src="../../../../assets/images/nothing/nothing.png">
      </div>
    </div>

    <!-- 人工成本列表 -->
    <div class="real-area-right">
      <div class="real-area-right-top right-top-active">
        <div class="real-area-right-top-search">
          <span class="real-area-right-top-search-title">日期：</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate"
          >
          </el-date-picker>
          <span class="real-area-right-top-search-title labor-company-title">劳务公司：</span>
          <el-select
            class="labor-company"
            v-model="companyId"
            placeholder="请选择劳务公司"
            clearable
          >
            <el-option
              v-for="item in laborServiceCompanyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
          <el-button icon="el-icon-refresh" class="btn-gray" @click="reset">重置</el-button>
        </div>
      </div>
      
      <div class="title-container">
        <p class="table-title">成本信息</p>
        <div class="btn-container">
          <div class="upload-real" @click="downLoadExcel">
            <span class="upload-real-img"></span>
            <span>导出</span>
          </div>
          <div class="upload-warehouse" @click="uploadExcel">
            <span class="upload-warehouse-img"></span>
            <span>人工成本导入</span>
          </div>
        </div>
      </div>
      <div class="real-area-right-container">
        <div class="table" v-if="tableData.length">
          <el-table :data="tableData" style="width: 100%" :header-cell-class-name="headerCellClassName">
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              show-overflow-tooltip
              :min-width="item.width"
              :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
            ></el-table-column>
          </el-table>
          <div class="pagination">
            <pagination-tpl
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @queryChange="queryChange"
            ></pagination-tpl>
          </div>
        </div>
        <div v-else class="nothing">
          <img class="nothing-labor-img" src="../../../../assets/images/nothing/labor-nothing.png">
        </div>
      </div>
    </div>

    <!-- 人工成本导入 -->
    <el-drawer
      class="export-real-area"
      title="人工成本导入"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <div class="el-drawer__body">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="tips">
            <img class="sign-blue" src="../../../../assets/images/sigh/sigh-blue.png">
            <span class="tips-content">导入临时工与正式工费用，算得人工成本</span>
            <span class="tips-text">（功能介绍）</span>
          </div>
          <p class="sub-title base-title">基本信息</p>
          <el-form-item label="仓库名称" prop="warehouseName">
            <el-input v-model="form.warehouseName" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="日期" prop="date" class="labor-date">
            <el-date-picker
              v-model="form.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              @change="changeLaborDate"
            ></el-date-picker>
          </el-form-item>
          <div class="sub-title cost-title">
            <span>人工成本信息</span>
            <el-button class="btn-text" type="text" @click="addCost"
              >+新增成本</el-button
            >
          </div>
          <div
            class="cost-container"
            v-for="(item, index) in form.costInfoList"
            :key="index"
          >
            <div class="cost-container-top">
              <div class="cost-nums">{{ index+1 }}</div>
              <div class="cost-remove" @click.prevent="removeCostInfo(item)">
                <i class="el-icon-delete"></i>
                删除
              </div>
            </div>
            <div class="cost-row">
              <el-form-item
                label="劳务公司" 
                :prop="'costInfoList.' + index + '.laborId'"
                :rules="{
                  required: true, message: '请选择劳务公司', trigger: 'change'
                }"
              >
                <el-select
                  class="white"
                  v-model="item.laborId"
                  placeholder="请选择项目"
                >
                  <el-option
                    v-for="item in laborServiceCompanyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item 
                label="总工时"
                :prop="'costInfoList.' + index + '.employeeHours'"
              >
                <el-input
                  v-model="item.employeeHours"
                  placeholder="请输入"
                  clearable
                  @input="employeeHoursInput(item.employeeHours, index)"
                ></el-input>
              </el-form-item>
            </div>
            <div class="cost-row">
              <el-form-item 
                label="工人工资" 
                :prop="'costInfoList.' + index + '.employeeCost'"
                :rules="{
                  required: true, message: '请输入工人工资', trigger: 'blur'
                }"
              >
                <el-input
                  v-model="item.employeeCost"
                  placeholder="请输入"
                  clearable
                  @input="employeeCostInput(item.employeeCost, index)"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="总人数"
                :prop="'costInfoList.' + index + '.employeeNum'"
              >
                <el-input
                  v-model="item.employeeNum"
                  placeholder="请输入"
                  clearable
                  @input="employeeNumInput(item.employeeNum, index)"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirm('form')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import warehouseMixins from "@/common/mixins/warehouse.js"
import LaborCost from "models/data-entry/labor-cost";
import LaborServiceCompanyListMixins from '@/common/mixins/labor-service-company.js'
import { formatTimeToDate, inputAllTwoDecimal, getInteger, numsToRMBSymbolAndMillimeter, downLoadFileByBlob } from "common/js/util";
export default {
  mixins: [warehouseMixins, LaborServiceCompanyListMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      // 选择的仓库id
      warehouseId: null,
      activeIndex: 0,
      date: this.timeDefault(),
      companyId: null,
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '日期', prop: 'createTime', width: '', alignment:'left'},
        {label: '劳务公司', prop: 'companyName', width: '', alignment:'left'},
        {label: '总人数', prop: 'totalPeople', width: '', alignment:'right'},
        {label: '总工时', prop: 'totalTimes', width: '', alignment:'right'},
        {label: '工人工资', prop: 'workerSarlay', width: '', alignment:'right'},
      ],

      drawer: false,
      form: {
        warehouseName: null,
        date: '',
        costInfoList: [
          {
            laborId: null,
            employeeNum: 0,
            employeeHours: 0,
            employeeCost: null,
          }
        ]
      },
      rules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'change' },
        ],
      },
    }
  },

  async created() {
    this.initLaborServiceCompanyList()
    await this.initFirstWarehouse()
  },

  methods: {
    /**
     * @desc 人工成本列表
     */
    initLaborCostList() {
      let warehouseId = this.warehouseId
      let currentPage = this.currentPage
      let laborId = this.companyId
      let startDate = this.date.length > 0 ? this.date[0] :''
      let endDate = this.date.length > 0 ? this.date[1] :''
      let data = {
        currentPage,
        laborId,
        warehouseId,
        startDate,
        endDate
      }
      LaborCost.getLaborCostList(data).then(res => {
        if (res.success) {
          let { totalNum, pageSize, items } = res.result
          this.total = totalNum
          this.pageSize = pageSize
          let arr = []
          items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.createTime = i.reportDate
            obj.companyName = i.laborName
            obj.warehouseName = i.warehouseName
            obj.totalPeople = i.quantity
            obj.totalTimes = i.employeeHours
            obj.workerSarlay = numsToRMBSymbolAndMillimeter(i.employeeAmount)
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 获取导入成本详情请
    */
    initLaborCostDetails() {
      let warehouseId = this.warehouseId
      let reportDate = this.form.date
      let data = {
        warehouseId,
        reportDate
      }
      LaborCost.getLaborCostDetails(data).then(res => {
        if (res.success) {
          if (res.result.length) {
            let arr = []
            res.result.map(i => {
              let obj = {}
              obj.laborId = i.laborId
              obj.employeeHours = i.employeeHours
              obj.employeeNum = i.employeeQuantity
              obj.employeeCost = i.employeeAmount
              arr.push(obj)
            })
            this.form.costInfoList = arr
          } else {
            this.form.costInfoList = [
              {
                laborId: null,
                employeeNum: 0,
                employeeHours: 0,
                employeeCost: null,
              }
            ]
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /**
     * @desc 默认选择第一个仓库
     */
    async initFirstWarehouse() {
      let startDate = this.date.length > 0 ? this.date[0] :''
      let endDate = this.date.length > 0 ? this.date[1] :''
      let laborId = this.companyId
      let optione = {
        startDate,
        endDate,
        laborId
      }
      await this.initAsyncWarehouseLaborCost(optione)
      if (this.warehouseList.length) {
        // 默认选择第一个仓库
        this.selectWarehouse(this.warehouseList[0], 0)
      } else {
        this.tableData = []
      }
    },
    
    timeDefault() {
      let date = new Date();
      const yesterday = formatTimeToDate(date.getTime() - 86400000)
      const firstDate = formatTimeToDate(date.setDate(1))
      let arr = [firstDate, yesterday]
      if (new Date().getDate() === 1)  arr = [firstDate, firstDate]
      return arr;
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex}) {
      if (columnIndex > 1) {
        return 'right-align'
      }
    },

    /**
     * @desc 选择日期
     */
    changeDate() {
      this.currentPage = 1;
      this.updatedAllWarehouseInfo()
    },

    async updatedAllWarehouseInfo() {
      let startDate = this.date.length > 0 ? this.date[0] :''
      let endDate = this.date.length > 0 ? this.date[1] :''
      let laborId = this.companyId
      let optione = {
        startDate,
        endDate,
        laborId
      }
      await this.initAsyncWarehouseLaborCost(optione)
      if (this.warehouseList.length) {
        this.initLaborCostList()
      } else {
        this.tableData = []
      }
    },
    
    reset() {
      this.date = this.timeDefault();
      this.companyId = null;
    },

    searchData() {
      this.currentPage = 1;
      this.updatedAllWarehouseInfo()
    },
    
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initLaborCostList()
    },

    /**
     * @desc 选择仓库初始化人工成本列表
     */
    selectWarehouse(row, index) {
      this.activeIndex = index
      this.form.warehouseName = row.name
      this.warehouseId = row.id
      this.initLaborCostList()
    },

    uploadExcel() {
      this.drawer = true
    },
    
    handleCloseDrawer() {
      this.$refs['form'].resetFields();
      this.form.costInfoList = [
          {
            laborId: null,
            employeeNum: 0,
            employeeHours: 0,
            employeeCost: null,
          }
        ]
      this.drawer = false
    },

    addCost() {
      let obj = {
        laborId: null,
        employeeCost: null,
        employeeNum: 0,
        employeeHours: 0,
      }
      this.form.costInfoList.push(obj)
    },

    removeCostInfo(item) {
      let index = this.form.costInfoList.indexOf(item)
      if (index !== -1) {
        this.form.costInfoList.splice(index, 1)
      }
    },

    /**
     * @desc 导入人工成本
     */
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.warehouseId
          let billDate = this.form.date
          let employeeCostInfoList = this.form.costInfoList
          let data = {
            warehouseId,
            billDate,
            employeeCostInfoList
          }
          LaborCost
            .postEntryLaborCost(data)
            .then(res => {
              if (res.success) {
                this.initLaborCostList();
                this.handleCloseDrawer()
              } else {
                this.$message.error(res.message);
              }
            })
         } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    
    employeeNumInput(v, index) {
      this.form.costInfoList[index].employeeNum = Number(getInteger(v));
    },
    employeeHoursInput(v, index) {
      this.form.costInfoList[index].employeeHours = inputAllTwoDecimal(v);
    },
    employeeCostInput(v, index) {
      this.form.costInfoList[index].employeeCost = inputAllTwoDecimal(v);
    },

    changeLaborDate() {
      this.initLaborCostDetails()
    },

    downLoadExcel() {
      let warehouseId = this.warehouseId
      let currentPage = this.currentPage
      let laborId = this.companyId
      let startDate = this.date.length > 0 ? this.date[0] :''
      let endDate = this.date.length > 0 ? this.date[1] :''
      let data = {
        currentPage,
        laborId,
        warehouseId,
        startDate,
        endDate
      }
      LaborCost.getExportLaborCostExcel(data).then((res) => {
        downLoadFileByBlob(res)
      });
    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/warehouse/real-area.scss';
</style>